import { ArrowRightIcon } from "lucide-react";

import { Button } from "@/components/ui/button";

export const ErrorFallback = ({ resetError }: { resetError: () => void }) => {
  const handleGoBack = () => {
    resetError();
    window.history.back();
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="flex min-h-svh flex-col items-center justify-center">
      <div className="flex flex-col gap-12">
        <div className="flex flex-col gap-4">
          <p className="font-semibold text-primary-700">Error</p>
          <p className="text-6xl font-semibold text-slate-900">
            Something went wrong
          </p>
          <p className="text-xl text-slate-500">
            We encountered an error. Try refreshing or heading back.
          </p>
        </div>
        <div className="flex items-center gap-3">
          <Button
            className="rounded-full"
            onClick={handleRefresh}
            variant="outlineSecondary"
          >
            Refresh
          </Button>
          <Button className="rounded-full" onClick={handleGoBack}>
            Go back
          </Button>
        </div>
        <div className="flex flex-col items-start">
          <a
            href="mailto:team@laborup.com"
            className="flex items-center gap-2 font-semibold text-primary-800"
          >
            Contact Us <ArrowRightIcon className="h-4 w-4" />
          </a>
          <p className="text-slate-500">
            If you need any help, feel free to contact us at team@laborup.com!
          </p>
        </div>
      </div>
    </div>
  );
};
